<a
  class="tw-flex tw-h-80 tw-w-full tw-min-w-[26rem] tw-flex-col tw-justify-between tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-p-4 tw-text-black"
  [routerLink]="campaign.slug | campaignCardLink: campaign.defaultView"
>
  <section class="tw-flex tw-items-start tw-justify-between">
    <div>
      <h3 class="tw-font-body tw-text-lg tw-font-bold tw-tracking-wide">
        {{ campaign.company.brandName }}
      </h3>
      <p class="tw-line-clamp-2 tw-text-sm tw-text-black">{{ campaign.company.tagline }}</p>
    </div>
    <img
      [src]="campaign.company.companyLogoUrl"
      [alt]="campaign.company.brandName"
      class="tw-h-20 tw-w-20 tw-rounded-md tw-border tw-border-black tw-object-cover tw-object-center"
    />
  </section>
  <app-tag-list
    [tags]="campaign.company?.sectors"
    [partnershipBacked]="campaign.partnershipBacked"
    [campaignImpacts]="campaign.campaignImpacts"
  />
  <div class="campaign-card__footer">
    <div class="tw-flex tw-flex-col">
      <!-- Raised amount -->
      @if (campaign.campaignStatus !== CampaignStatus.PreLive) {
        <div>
          <div class="campaign-card__stat-label p-text-tag">
            {{ 'campaign.raised' | translate }}
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <div class="campaign-card__numbers tw-mr-auto tw-text-black">
              {{ campaign.bankedInAmount | numberSuffix }}
              ({{ calculateRaisedPercentage() }}%)
            </div>
            <!-- Show days left -->
            <div class="campaign-card__dayleft tw-whitespace-nowrap">
              @if (
                campaign.campaignStatus === CampaignStatus.Live &&
                !campaign.isEnded &&
                calculateDayLeft(campaign.endAt) >= 2
              ) {
                <span>
                  {{ campaign.endAt | amDifference: today : 'days' : true | number: '1.0-0' }}
                  {{
                    'campaign.daysLeft_plural'
                      | translate: { 'count': calculateDayLeft(campaign.endAt) }
                  }}
                </span>
              }
              @if (campaign.campaignStatus === CampaignStatus.Live && campaign.isTomorrow) {
                <span>
                  {{ 'campaign.endTomorrow' | translate }}
                </span>
              }
              @if (campaign.campaignStatus === CampaignStatus.Live && campaign.isToday) {
                <span>
                  {{ 'campaign.endToday' | translate }}
                </span>
              }
              @if (
                (campaign.campaignStatus !== CampaignStatus.Cooling && campaign.isEnded) ||
                campaign.campaignStatus === CampaignStatus.ShareAllotment
              ) {
                <span class="tw-text-secondary-light">
                  {{ 'campaign.funded' | translate }}
                </span>
              }
              @if (campaign.campaignStatus === CampaignStatus.Fail) {
                <span>
                  {{ 'campaign.Fail' | translate }}
                </span>
              }
            </div>
            <!-- Cooling off label -->
            @if (campaign.campaignStatus === CampaignStatus.Cooling) {
              <div
                class="campaign-card__status tw-whitespace-nowrap tw-rounded tw-bg-info-light tw-px-2"
              >
                {{ 'campaign.' + CampaignStatus[campaign.campaignStatus] | translate }}
              </div>
            }
          </div>
        </div>
      }

      @if (campaign.campaignStatus === CampaignStatus.PreLive) {
        <div class="tw-w-fit tw-rounded tw-bg-warning-light tw-px-2">
          {{ 'campaign.launchingSoon' | translate }}
        </div>
      }

      <!-- Progress bar -->
      @if (
        campaign.campaignStatus === CampaignStatus.Live ||
        campaign.campaignStatus === CampaignStatus.Cooling
      ) {
        <div class="tw-my-2.5">
          <mat-progress-bar
            aria-label="progressbar"
            mode="determinate"
            height="10"
            [color]="campaign.raisedPercentage > 100 ? 'success' : ''"
            [value]="calculateProgress(campaign.raisedPercentage)"
          >
          </mat-progress-bar>
        </div>
      } @else {
        <div class="tw-my-3.5">
          <hr class="tw-my-0 tw-border-divider" />
        </div>
      }

      <div
        class="campaign-card__stats tw-grid tw-divide-x tw-divide-y-0 tw-divide-solid tw-divide-divider"
        [class.tw-grid-cols-3]="campaign.campaignStatus !== CampaignStatus.PreLive"
        [class.tw-grid-cols-2]="campaign.campaignStatus === CampaignStatus.PreLive"
      >
        <!-- Valuation -->
        <div class="campaign-card__stat">
          <div class="campaign-card__stat-label p-text-tag tw-text-black">
            {{ 'campaign.valuation' | translate }}
          </div>
          <div
            class="campaign-card__numbers tw-text-sm tw-font-bold tw-proportional-nums tw-text-black"
          >
            {{
              campaign.valuationAmount
                | numberSuffix
                  : {
                      isSuffix: true,
                      numberFormat: campaign.valuationAmount >= 1000000 ? '1.1-1' : '1.0-1',
                    }
            }}
          </div>
        </div>

        <!-- Target -->
        <div class="campaign-card__stat tw-pl-2">
          <div class="campaign-card__stat-label p-text-tag tw-text-black">
            {{ 'campaign.minTarget' | translate }}
          </div>
          <div
            class="campaign-card__numbers tw-text-sm tw-font-bold tw-proportional-nums tw-text-black"
          >
            {{
              campaign.minimumTargetAmount
                | numberSuffix
                  : {
                      isSuffix: true,
                      numberFormat: campaign.minimumTargetAmount >= 1000000 ? '1.1-1' : '1.0-1',
                    }
            }}
          </div>
        </div>

        <!-- Investors -->
        @if (campaign.campaignStatus !== CampaignStatus.PreLive) {
          <div class="campaign-card__stat tw-pl-2">
            <div class="campaign-card__stat-label p-text-tag tw-text-black">
              {{ 'campaign.investors' | translate }}
            </div>
            <div
              class="campaign-card__numbers tw-text-sm tw-font-bold tw-proportional-nums tw-text-black"
            >
              {{ campaign.investorCount | number }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</a>
